module.exports = __webpack_public_path__ + "img/yellow_pet_celebration.ecad170a.gif";